import { render } from "./EmptyPage.vue?vue&type=template&id=db5f7210"
import script from "./EmptyPage.vue?vue&type=script&lang=js"
export * from "./EmptyPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/eAzC_LUi/0/econsultingsistemas/certificadorweb/certificador-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__